export const normalizeKnowledgeText = (value = '') => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const KNOWLEDGE_TOPICS = [
  {
    slug: 'hidratalas-es-borkomfort', title: 'Hidratálás és bőrkomfort', icon: 'droplet',
    question: 'Húzódik a bőröd, vagy nehéz megtalálni a megfelelő krémet?',
    description: 'Hidratáló rutinok, Hada Labo lotionök és arckrémek: segítség a kényelmesebb mindennapi bőrápoláshoz.',
    intro: 'Egy jól használható rutin néhány összeillő lépéssel kezdődik. Itt a tisztítás, a lotion, a szérum és a krém közötti választáshoz találsz útmutatókat. Indulj a saját bőrérzetedből és a már bevált termékeidből, majd egyszerre csak egy új lépést próbálj ki.',
    start: ['vizhianyos-bor-hidratalo-rutin', 'hada-labo-lotion-hasznalata'],
    brands: ['hada-labo-tokyo', 'sinoz', 'aurodhea', 'cosrx'],
    pattern: /arckrem|hidratal|vizhiany|szaraz-bor|hideg-teli|erzekeny-bor|hada-labo|borapolasi-tippek|koreai-arcapolas|csiganyal|creem/,
  },
  {
    slug: 'egyseges-borkep-es-fenyvedelem', title: 'Egységes bőrkép és fényvédelem', icon: 'sun',
    question: 'Pigmentfoltok, fakó bőrkép vagy túl sokféle szérum?',
    description: 'Pigmentfolt elleni kozmetikumok, C-vitamin, niacinamid és fényvédelem: átgondolt választás, reális elvárások.',
    intro: 'A termék neve önmagában nem mondja el, hogyan illik a rutinodba. Ezek az útmutatók segítenek átlátni a kozmetikumok szerepét, az alkalmazás sorrendjét és a fényvédelem helyét. Új vagy változó bőrelváltozás esetén először bőrgyógyász segíthet tisztázni az okot.',
    start: ['pigmentfolt-elleni-krem-valasztas', 'c-vitamin-szerum-hasznalata'],
    brands: ['sinoz', 'beauty-of-joseon', 'anua', 'cosrx'],
    pattern: /pigment|fenyved|c-vitamin|niacinamid|borkep|fako/,
  },
  {
    slug: 'haj-es-fejborapolas', title: 'Haj- és fejbőrápolás', icon: 'sparkles',
    question: 'Milyen sampont, balzsamot vagy fejbőrápolót válassz?',
    description: 'Aurodhea samponok és hajápolók összehasonlítása, használati szempontok és egyszerű hajápolási rutinok.',
    intro: 'A sampon, a hajhosszra való ápoló és a fejbőrön használt készítmény különböző feladatot lát el. Nézd meg, melyik lépés hiányzik a rutinodból, mielőtt új terméket választasz. Tartós vagy hirtelen hajhullást érdemes szakemberrel kivizsgáltatni.',
    start: ['aurodhea-sampon-lotion-ampulla-kulonbseg'], brands: ['aurodhea', 'chogan'],
    pattern: /sampon|hajhull|fejbor|hajapol|hajmos|balzsam/,
  },
  {
    slug: 'parfumvalasztas', title: 'Parfümválasztás', icon: 'flower',
    question: 'Új illatot keresel magadnak vagy ajándékba?',
    description: 'Chogan, Olfazeta és Yodeyma: illatcsaládok, kiszerelések, tartósság és támpontok az online parfümválasztáshoz.',
    intro: 'Kezdj azzal, milyen illatokat szeretsz és mikor viselnéd a parfümöt. A népszerűség mellett az illatcsalád, a kipróbálás lehetősége és a kiszerelés is számít. Az útmutatók mellé közvetlenül eléred a Melini márkaoldalait és az illatkeresőt.',
    start: ['yodeyma-parfum-valasztasi-utmutato', 'a-chogan-parfumok-szamozasa-hogyan-azonosithatod-be'],
    brands: ['yodeyma', 'chogan'], pattern: /parfum|chogan-illat|top-illatok|olfazeta/,
  },
  {
    slug: 'illoolajok-hasznalata', title: 'Illóolajok használata', icon: 'leaf',
    question: 'Először vásárolsz illóolajat, vagy elakadtál a használatával?',
    description: 'doTERRA útmutatók a formátumválasztáshoz, a címke értelmezéséhez, a párologtatáshoz és a körültekintő használathoz.',
    intro: 'Az illóolaj, a Touch, a kapszula és a kész kozmetikum nem felcserélhető termék. A kiindulópont mindig az adott kiszerelés címkéje és rendeltetése. Itt a gyakori vásárlási és használati kérdésekre kapsz választ, gyógyhatásra vonatkozó ígéretek nélkül.',
    start: ['kezdo-doterra-vasarlasi-utmutato-az-elso-5-illoolaj', 'teafaolaj-belsoleg-es-kulsoleg'],
    brands: ['doterra', 'lolum'], pattern: /illoolaj|doterra|teafa|tomjen|borsmenta|levendula|citrom-olaj|touch|diffuzor|parologtato|lolum/,
  },
  {
    slug: 'otthoni-wellness-es-esti-rutin', title: 'Otthoni wellness és esti rutin', icon: 'moon',
    question: 'Szeretnél egy kellemesebb esti rutint vagy otthoni pihenősarkot?',
    description: 'Otthoni wellnessötletek, illatválasztás, doTERRA Serenity és a mindennapokba illeszthető pihenési szokások.',
    intro: 'A pihenéshez nem kell bonyolult terméklista. Tervezd meg, mi fér bele az estédbe, milyen illatot kedvelsz, és mely lépéseket tudod rendszeresen megtartani. Ezek a cikkek a környezet és a rutin kialakításában segítenek; tartós alvásproblémára nem kínálnak kezelést.',
    start: ['esti-nyugodt-rutin-illoolajokkal-balance-serenity-es-adaptiv', 'on-guard-termekek-kozotti-kulonbsegek'],
    brands: ['doterra', 'frais-monde'], pattern: /esti|wellness|relax|nyugal|nyugodt|alvas|stressz|harmonia|erdei-hangulat|on-guard|aromaterapia/,
  },
];

export const HUB_BRANDS = [
  ['doterra', 'doTERRA'], ['chogan', 'Chogan / Olfazeta'], ['yodeyma', 'Yodeyma'],
  ['hada-labo-tokyo', 'Hada Labo Tokyo'], ['sinoz', 'SiNOZ'], ['aurodhea', 'Aurodhea'],
  ['cosrx', 'COSRX'], ['beauty-of-joseon', 'Beauty of Joseon'], ['anua', 'Anua'],
  ['lolum', 'Lolûm'], ['frais-monde', 'Frais Monde'],
];

// These legacy articles remain at their original URLs but need editorial review
// before being promoted in the new hub.
const REVIEW_BEFORE_PROMOTION = new Set([
  'termeszetes-megoldas-kohoges-ellen', 'termeszetes-megoldasok-fejfajas-ellen',
  'illoolaj-kohogesre', 'doterra-a-borapolas-fontossaga',
]);

export const topicPath = (slug) => `/tudastar/tema/${slug}/`;
export const articlePath = (article) => `/${article.kind === 'blog' ? 'blog' : 'tudastar'}/${article.slug}/`;
export function getArticleTopics(article) {
  if (!article || REVIEW_BEFORE_PROMOTION.has(article.slug)) return [];
  const text = normalizeKnowledgeText([article.slug, article.title, ...(article.tags || [])].join(' '));
  return KNOWLEDGE_TOPICS.filter((topic) => topic.pattern.test(text));
}
export function matchesHubBrand(article, brand) {
  if (!brand) return true;
  const text = normalizeKnowledgeText([article.title, article.excerpt, ...(article.tags || []), ...(article.relatedProductSlugs || [])].join(' '));
  const terms = { chogan: ['chogan', 'olfazeta'], 'hada-labo-tokyo': ['hada labo', 'hada-labo'], 'beauty-of-joseon': ['beauty of joseon', 'beauty-of-joseon'], 'frais-monde': ['frais monde', 'frais-monde'] };
  return (terms[brand] || [brand]).some((term) => text.includes(term));
}
